import { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { errorToast } from '../lib/toastAlert'
import { Spinner } from '../components/Spinner'

export function Sellers() {
  const [sellers, setSellers] = useState([])
  const [keyword, setKeyword] = useState('')
  const [selectedPage, setSelectedPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)

  const handlePageChange = (page) => {
    setSelectedPage(page.selected + 1)
  }

  useEffect(() => {
    App.Request.get('/cars/dealers.json', {
      params: {
        keyword,
        page: selectedPage,
      },
    })
      .then((response) => {
        const { data, status } = response

        if (status === 200) {
          setSellers(data.sellers)
          setTotal(data.total)
        }
      })
      .catch(() => {
        errorToast()
      })
      .finally(() => setLoading(false))
  }, [keyword, selectedPage])

  return (
    <div>
      <div className="col-lg-6 my-3 sellers-search-form col-auto m-auto">
        <input
          type="text"
          placeholder={`${I18n.t('find_dealers')} ...`}
          onChange={(e) => setKeyword(e.target.value)}
          className="form-control"
        />
      </div>

      {loading && <Spinner loadingText={`${I18n.t('loading')}...`} />}
      <section className="my-6">
        <ul className="list-unstyled row">
          {!loading &&
            sellers.length > 0 &&
            sellers.map((seller) => (
              <li className="col-12 mb-5" ey={seller.id}>
                <div className="card p-3 p-md-0">
                  <div className="row my-3 align-items-center">
                    <a
                      className="col-md-2 border-end border-gray-dark d-none d-md-inline-block"
                      href={seller.path}
                    >
                      <img
                        src={seller.avatar}
                        alt="Avatar"
                        className="img-fluid ps-3"
                        width="100"
                        height="100"
                      />
                    </a>

                    <div className="col-md-7">
                      <h2 className="mb-0">
                        <a href={seller.path}>{seller.display_name}</a>
                      </h2>
                      <p className="mt-1 mb-0">{seller.short_description}</p>
                    </div>
                    <div className="col-md-3">
                      <div className="pe-md-3 text-end text-sm-start">
                        <ul className="list-unstyled border rounded bodrder-dark-gray d-inline-block mb-3 mb-md-6">
                          <li className="border-end py-2 px-3 d-inline-block">
                            <i className="far fa-car" />
                          </li>
                          <li className="text-primary text-lg py-1 px-3 d-inline-block">
                            {seller.published_cars_count}
                          </li>
                        </ul>
                        <div>
                          <a
                            className="btn d-md-inline-block d-block btn-primary px-6"
                            href={seller.path}
                          >
                            {I18n.t('profile')}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
        </ul>
      </section>

      <nav aria-label="Dealers result pagination">
        <ReactPaginate
          previousLabel={<i className="fas fa-chevron-left" />}
          nextLabel={<i className="fas fa-chevron-right" />}
          activeClassName="active"
          breakClassName="page-item"
          breakLinkClassName="page-link"
          pageCount={Math.ceil(total / 10)}
          pageRangeDisplayed={4}
          marginPagesDisplayed={2}
          forcePage={selectedPage - 1}
          containerClassName="pagination justify-content-center"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          disabledClassName="disabled"
          onPageChange={handlePageChange}
        />
      </nav>
    </div>
  )
}
